import React, { useContext, useState, useEffect } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  Spinner,
  InputGroup,
  Dropdown,
} from "@themesberg/react-bootstrap";
import { Context } from "../SalesTicketStorage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faFilter,
  faMapMarkerAlt,
  faTicketAlt,
  faBarcode,
  faSortNumericDown,
  faCalendarAlt,
  faFileExport,
} from "@fortawesome/free-solid-svg-icons";
import { getAllChannel } from "../../../../controller/api/__classic__/channel";
import { useCookies } from "react-cookie";
import { includesSearchText } from "../../../../helper/text";
import ExportProcessingPopup from "../sub-screen/ExportProcessingPopup";

const _FilterForm = ({
  region,
  showRegionSelect,
  selectedRegion,
  onRegionChange,
}) => {
  const { dispatch, state } = useContext(Context);
  const [cookies] = useCookies(["lottmekong"]);

  const [searchNumbers, setSearchNumbers] = useState("");
  const [searchTicketCode, setSearchTicketCode] = useState("");
  const [ticketType, setTicketType] = useState("all");
  const [selectedChannel, setSelectedChannel] = useState("");
  const [channelSearch, setChannelSearch] = useState("");
  const [channels, setChannels] = useState([]);
  const [fromDate, setFromDate] = useState(state.fromDate || "");
  const [toDate, setToDate] = useState(state.toDate || "");
  const [showExport, setShowExport] = useState(false);

  useEffect(() => {
    setFromDate(state.fromDate || "");
    setToDate(state.toDate || "");
  }, [state.fromDate, state.toDate]);

  // Fetch channels when region changes
  useEffect(() => {
    const fetchChannels = async () => {
      const response = await getAllChannel(cookies.lottmekong, region);
      if (response && response.data) {
        setChannels(response.data);
      }
    };
    fetchChannels();
    // Reset selected channel when region changes
    setSelectedChannel("");
    setChannelSearch("");
  }, [region, cookies.lottmekong]);

  const filteredChannels = channelSearch
    ? channels.filter((channel) =>
        includesSearchText(channel.name, channelSearch),
      )
    : channels;

  const handleSearch = () => {
    dispatch({
      type: "SUBMIT_FILTER",
      payload: {
        channel: selectedChannel,
        numbers: searchNumbers.replace(/\s/g, ""),
        ticketCode: searchTicketCode.replace(/\s/g, ""),
        ticketType: ticketType,
        fromDate: fromDate,
        toDate: toDate,
      },
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const getTitle = () => {
    if (showRegionSelect) {
      return "Tìm kiếm & Lọc vé";
    }
    return `Vé ${region === "MN" ? "Miền Nam" : "Miền Trung"} đang bán`;
  };

  const exportFilterData = {
    region: region,
    channel: state.channel,
    channelName:
      channels.find((ch) => String(ch.id) === String(state.channel))?.name ||
      "",
    numbers: state.numbers,
    ticketCode: state.ticketCode,
    ticketType: state.ticketType,
    fromDate: state.fromDate,
    toDate: state.toDate,
  };

  return (
    <>
      <Card border="light" className="shadow-sm mb-4 border-0">
        <Card.Body className="p-4">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h5 className="mb-0 text-primary fw-bold">
              <FontAwesomeIcon icon={faFilter} className="me-2" />
              {getTitle()}
            </h5>
          </div>

          <Row className="g-3">
            {/* Row 1: Select Filters */}
            {showRegionSelect && (
              <Col md={4} lg={2}>
                <Form.Label className="fw-bold mb-2">Khu vực</Form.Label>
                <InputGroup>
                  <InputGroup.Text className="bg-light border-end-0 text-primary">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="fa-fw" />
                  </InputGroup.Text>
                  <Form.Select
                    value={selectedRegion}
                    onChange={(e) => onRegionChange(e.target.value)}
                    className="border-start-0 ps-0 bg-light fw-bold"
                  >
                    <option value="MN">Miền Nam</option>
                    <option value="MT">Miền Trung</option>
                  </Form.Select>
                </InputGroup>
              </Col>
            )}

            <Col md={showRegionSelect ? 4 : 6} lg={showRegionSelect ? 2 : 3}>
              <Form.Label className="fw-bold mb-2">Đài (Tỉnh)</Form.Label>
              <Dropdown className="w-100">
                <Dropdown.Toggle
                  variant="white"
                  className="w-100 text-start d-flex align-items-center justify-content-between form-control bg-light border"
                  id="dropdown-channel-select"
                >
                  <span className="text-truncate">
                    {selectedChannel
                      ? channels.find(
                          (ch) => String(ch.id) === String(selectedChannel),
                        )?.name || "Tất cả đài"
                      : "Tất cả đài"}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="w-100 p-2 shadow-sm"
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                >
                  <div className="px-1 mb-2 sticky-top bg-white">
                    <InputGroup>
                      <InputGroup.Text className="bg-white border-end-0">
                        <FontAwesomeIcon
                          icon={faSearch}
                          className="text-muted"
                        />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        placeholder="Tìm đài..."
                        value={channelSearch}
                        onChange={(e) => setChannelSearch(e.target.value)}
                        className="bg-white border-start-0 ps-0"
                        onClick={(e) => e.stopPropagation()}
                      />
                    </InputGroup>
                  </div>

                  <Dropdown.Item
                    active={selectedChannel === ""}
                    onClick={() => {
                      setSelectedChannel("");
                      setChannelSearch("");
                    }}
                    className="rounded-2"
                  >
                    Tất cả đài
                  </Dropdown.Item>

                  {filteredChannels.length > 0 ? (
                    filteredChannels.map((channel) => (
                      <Dropdown.Item
                        key={channel.id}
                        active={String(selectedChannel) === String(channel.id)}
                        onClick={() => {
                          setSelectedChannel(channel.id);
                          setChannelSearch("");
                        }}
                        className="rounded-2"
                      >
                        {channel.name}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <div className="text-center text-muted small py-2">
                      Không tìm thấy đài
                    </div>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            <Col md={showRegionSelect ? 4 : 6} lg={showRegionSelect ? 2 : 3}>
              <Form.Label className="fw-bold mb-2">Loại vé</Form.Label>
              <InputGroup>
                <InputGroup.Text className="bg-light border-end-0 text-primary">
                  <FontAwesomeIcon icon={faTicketAlt} className="fa-fw" />
                </InputGroup.Text>
                <Form.Select
                  value={ticketType}
                  onChange={(e) => setTicketType(e.target.value)}
                  className="border-start-0 ps-0 bg-light"
                >
                  <option value="all">Tất cả loại vé</option>
                  <option value="single">Vé đơn</option>
                  <option value="pair">Vé cặp nguyên</option>
                </Form.Select>
              </InputGroup>
            </Col>

            {/* Text Search Inputs */}
            <Col md={6} lg={2}>
              <Form.Label className="fw-bold mb-2">Tìm theo dãy số</Form.Label>
              <InputGroup>
                <InputGroup.Text className="bg-white text-muted">
                  <FontAwesomeIcon icon={faSortNumericDown} />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Nhập dãy số..."
                  value={searchNumbers}
                  onChange={(e) => setSearchNumbers(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
              </InputGroup>
            </Col>

            <Col md={6} lg={2}>
              <Form.Label className="fw-bold mb-2">Tìm theo mã vé</Form.Label>
              <InputGroup>
                <InputGroup.Text className="bg-white text-muted">
                  <FontAwesomeIcon icon={faBarcode} />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Nhập mã vé..."
                  value={searchTicketCode}
                  onChange={(e) => setSearchTicketCode(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
              </InputGroup>
            </Col>

            {/* Date Range Filters */}
            <Col md={6} lg={2}>
              <Form.Label className="fw-bold mb-2">Từ ngày</Form.Label>
              <InputGroup
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  const input =
                    e.currentTarget.querySelector('input[type="date"]');
                  if (input && input.showPicker) {
                    input.showPicker();
                  } else if (input) {
                    input.focus();
                  }
                }}
              >
                <InputGroup.Text className="bg-white text-muted">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </InputGroup.Text>
                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  onKeyPress={handleKeyPress}
                  style={{ cursor: "pointer" }}
                />
              </InputGroup>
            </Col>

            <Col md={6} lg={2}>
              <Form.Label className="fw-bold mb-2">Đến ngày</Form.Label>
              <InputGroup
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  const input =
                    e.currentTarget.querySelector('input[type="date"]');
                  if (input && input.showPicker) {
                    input.showPicker();
                  } else if (input) {
                    input.focus();
                  }
                }}
              >
                <InputGroup.Text className="bg-white text-muted">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </InputGroup.Text>
                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  onKeyPress={handleKeyPress}
                  style={{ cursor: "pointer" }}
                />
              </InputGroup>
            </Col>

            {/* Search Button */}
            <Col md={12} lg={2}>
              <Form.Label
                className="fw-bold mb-2 d-none d-lg-block"
                style={{ visibility: "hidden" }}
              >
                Tìm kiếm
              </Form.Label>
              <Button
                variant="primary"
                onClick={handleSearch}
                className="w-100 fw-bold text-uppercase shadow-sm"
                style={{ letterSpacing: "1px" }}
                disabled={state.isLoading}
              >
                {state.isLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Tìm...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faSearch} className="me-2" />
                    Tìm kiếm
                  </>
                )}
              </Button>
            </Col>

            <Col md={12} lg={2}>
              <Form.Label
                className="fw-bold mb-2 d-none d-lg-block"
                style={{ visibility: "hidden" }}
              >
                Xuất Excel
              </Form.Label>
              <Button
                variant="success"
                onClick={() => setShowExport(true)}
                className="w-100 fw-bold text-uppercase shadow-sm"
                style={{ letterSpacing: "1px" }}
                disabled={state.isLoading}
              >
                <FontAwesomeIcon icon={faFileExport} className="me-2" />
                Xuất Excel
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <ExportProcessingPopup
        show={showExport}
        onHide={() => setShowExport(false)}
        filterData={exportFilterData}
      />
    </>
  );
};

export default React.memo(_FilterForm);
